class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close(),
    );
    this.querySelector('#CartDrawer-Overlay').addEventListener(
      'click',
      this.close.bind(this),
    );
    this.setHeaderCartIconAccessibility();

    this.updateHeightCartItems();
    window.addEventListener('resize', this.updateHeightCartItems.bind(this));
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role'))
      this.setSummaryAccessibility(cartDrawerNote);

    setTimeout(() => {
      this.classList.add('animate', 'active');
      document.body.classList.add('drawer-open');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement =
          this.querySelector('.drawer__inner') ||
          this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      {once: true},
    );
    this.lockScroll();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    this.unlockScroll();
    document.body.classList.remove('drawer-open');
  }

  lockScroll(){
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollTop}px`;
    document.body.style.width = '100%';
  }

  unlockScroll(){
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute(
        'aria-controls',
        cartDrawerNote.nextElementSibling.id,
      );
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open'),
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    //console.log("PArsed State")
    // console.log(parsedState)
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
      );
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener(
        'click',
        this.close.bind(this),
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }
  setActiveElement(element) {
    this.activeElement = element;
  }

  updateHeightCartItems() {
    const cartDrawers = document.querySelectorAll('cart-drawer');
    cartDrawers.forEach((cartDrawer) => {
      const cartItems = cartDrawer.querySelector('cart-drawer-items.has-protection-product-wrapper .cart-wrapper');
      const cartFooter = cartDrawer.querySelector('cart-drawer-items > .drawer__footer');
      const cartDrawerItem =  cartDrawer.querySelector('cart-drawer-items');
      if (cartFooter) {
        const isIOS = this.checkiOS();
        let cartFooterHeight = cartFooter.offsetHeight - 20;
        let cartDrawerItemHeight = 70;
        if (window.screen.width > 767) {
            cartDrawerItemHeight = 70;
          } else {
            cartDrawerItemHeight = 180;
          }
        if (!isIOS) {
          if (window.screen.width > 767) {
            cartDrawerItemHeight = 70;
            cartFooterHeight = cartFooter.offsetHeight;
          } else {
            cartDrawerItemHeight = 180;
            cartFooterHeight = cartFooter.offsetHeight - 110;
          }
        }
        if (cartItems) {
          cartItems.style.maxHeight = `calc(100% - ${cartFooterHeight}px)`;
        }
        if (cartDrawerItem) {
          cartDrawerItem.style.height = `calc(100vh - ${cartDrawerItemHeight}px)`;
        }
      }
    })
  }

  checkiOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (!customElements.get('cart-protection-product')) {
  customElements.define('cart-protection-product',
    class CartProtectionProduct extends HTMLElement {
      constructor() {
        super();
        this.buttonAdd = this.querySelector('.cart__add-protection-product');
        this.buttonAdd.addEventListener('click', this.addProtectionProduct.bind(this))
      }
      addProtectionProduct(event) {
        event.preventDefault();
        const protectionProductId = this.buttonAdd.getAttribute('data-protection-product-id');
        let formData = {
          'items': [{
            'id': protectionProductId,
            'quantity': 1
          }]
        };
        fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }).then(function() {
          window.dispatchEvent(new CustomEvent('abra:render'));
          window.location.href = '/checkout';
        })
        .catch(error => console.error('Error:', error));
      }
    }
  )
}
